export default __webpack_public_path__ + "static/media/BY.c1555bff.svg";